import { render, staticRenderFns } from "./PoliciesSave.vue?vue&type=template&id=50ca0756&"
import script from "./PoliciesSave.vue?vue&type=script&lang=js&"
export * from "./PoliciesSave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports